<script setup>
import { ref, computed, watch } from 'vue'
import { Head, useForm, usePage } from '@inertiajs/vue3';
import { Tab, TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/vue'
import Checkbox from 'primevue/checkbox';
import axios from 'axios';
import { Switch } from '@headlessui/vue';
import InputNumber from 'primevue/inputnumber';
import { hasPermission } from '../../../Composables/userHelper'
import GoogleAutoComplete from '../../../Components/GoogleAutoComplete.vue'
import InputGroup from 'primevue/inputgroup';
import InputGroupAddon from 'primevue/inputgroupaddon';
import InputText from 'primevue/inputtext';

let eurFormatter = new Intl.NumberFormat('nl-NL', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});

const props = defineProps({
  categories: Array,
  brands: Array,
  fees: Array,
  options: Array,
  frontendOptions: Array,
  conditions: Array,
  brands: Array,
  categories: Array,
})

const page = usePage();
const user = computed(() => page.props.auth.user);

const categories = ref(props.categories);
const conditions = ref(props.conditions);
const brands = ref(props.brands);

const options = ref(props.options);
const frontendOptions = ref(props.frontendOptions);

const passwordForm = useForm({
  current_password: null,
  password: null,
  password_confirmation: null,
});

const newCategoryForm = useForm({
  name: null,
});

const categoryForm = useForm({
  id: null,
  name: null,
});

const newBrandForm = useForm({
  name: null,
});

const brandForm = useForm({
  id: null,
  name: null,
});

const feeForm = useForm({
  max: props.fees.map(fee => fee.max),
  fee: props.fees.map(fee => fee.fee),
})

const notificationsForm = useForm({
  email: {
    new_offer: user.value.notification_settings.email.new_offer,
    personal_offer: user.value.notification_settings.email.personal_offer,
  }
})

//on notifcationform change, submit the form
watch(notificationsForm, () => {
  axios.post(`/portal/settings/notifications`, { notifications: notificationsForm })
    .then(response => {
      //TODO SHOW SUCCESS MESSAGE
    })
    .catch(error => {
      //
    })
}, { deep: true })

//add a single entry to the fees, this is the "new" field
function addFee() {
  feeForm.max.push(null)
  feeForm.fee.push(null)
}

function deleteFee(index) {
  feeForm.max.splice(index, 1)
  feeForm.fee.splice(index, 1)
}

const optionForm = useForm({
  id: null,
  name: null,
});

const newOptionForm = useForm({
  name: null,
});

const questionForm = useForm({
  id: null,
  question: null,
  condition_category_id: null,
});

const conditionCategoryForm = useForm({
  id: null,
  name: null,
});

function saveFrontendOptions() {
  axios.post(`/portal/settings/frontendOptions`, { frontendOptions: frontendOptions.value })
    .then(response => {
      //TODO SHOW SUCCESS MESSAGE
    })
    .catch(error => {
      //
    })
}

function deleteOption(id) {
  axios.delete(`/portal/settings/option/${id}`)
    .then(response => {
      //remove the option from props.options with given id
      options.value = options.value.filter(option => option.id !== id)

      //remove the option from frontendOptions with given id
      frontendOptions.value = frontendOptions.value.filter(option => option !== id)
    })
    .catch(error => {
      console.log(error)
    })
}

const editing = ref(false);

function closeOptionEdit() {
  if (editing.value) {
    //hide the input
    document.getElementById(`option_${optionForm.id}_input`).classList.add('!hidden')
    //show the display
    document.getElementById(`option_${optionForm.id}_display`).classList.remove('!hidden')

    //hide check
    document.getElementsByClassName(`option_${optionForm.id}_check`)[0].classList.add('!hidden')
    //show pencil
    document.getElementsByClassName(`option_${optionForm.id}_pencil`)[0].classList.remove('!hidden')
  }
}

function editOption(option) {
  editing.value = true;
  if (optionForm.id === option.id) {
    //submit the form
    updateOptionForm()
    editing.value = false;
    return;
  }

  optionForm.id = option.id
  optionForm.name = option.name

  //hide the display
  document.getElementById(`option_${option.id}_display`).classList.add('!hidden')

  //show the input
  document.getElementById(`option_${option.id}_input`).classList.remove('!hidden')

  //hide pencil
  document.getElementsByClassName(`option_${option.id}_pencil`)[0].classList.add('!hidden')

  //show check
  document.getElementsByClassName(`option_${option.id}_check`)[0].classList.remove('!hidden')

  //close the other edit fields
  options.value.forEach(allOption => {
    if (allOption.id !== option.id) {
      //hide the display
      document.getElementById(`option_${allOption.id}_display`).classList.remove('!hidden')

      //show the input
      document.getElementById(`option_${allOption.id}_input`).classList.add('!hidden')

      //show pencil
      document.getElementsByClassName(`option_${allOption.id}_pencil`)[0].classList.remove('!hidden')

      //hide check
      document.getElementsByClassName(`option_${allOption.id}_check`)[0].classList.add('!hidden')
    }
  })
}

function updateOptionForm() {
  optionForm.post(`/portal/settings/option`, {
    preserveScroll: true,
    onSuccess: (data) => {
      //update the option in props.options with given id
      options.value = options.value.map(option => {
        if (option.id === optionForm.id) {
          option.name = optionForm.name
        }
        return option
      })

      //hide the input
      document.getElementById(`option_${optionForm.id}_input`).classList.add('!hidden')
      //show the display
      document.getElementById(`option_${optionForm.id}_display`).classList.remove('!hidden')

      //show pencil
      document.getElementsByClassName(`option_${optionForm.id}_pencil`)[0].classList.remove('!hidden')

      //hide check
      document.getElementsByClassName(`option_${optionForm.id}_check`)[0].classList.add('!hidden')

      optionForm.reset();
    }
  });
}

function submitOptionForm() {
  newOptionForm.post(`/portal/settings/option`, {
    preserveScroll: true,
    onSuccess: (data) => {
      options.value = data.props.options;
      newOptionForm.reset();
    }
  });
}

function editFees() {
  //hide editFeesButton
  document.getElementById('editFeesButton').classList.add('!hidden')
  //show saveFeesButton
  document.getElementById('saveFeesButton').classList.remove('!hidden')

  //hide feesTable
  document.getElementById('feesTable').classList.add('!hidden')

  //show editFees
  document.getElementById('editFees').classList.remove('!hidden')

  //enable addFeesButton
  document.getElementById('addFeeButton').classList.remove('!hidden')
}

function saveFees() {
  feeForm.post('/portal/settings/fees', {
    preserveScroll: true,
    onSuccess: (data) => {
      props.fees = data.props.fees;
      feeForm.reset();

      //hide editFeesButton
      document.getElementById('editFeesButton').classList.remove('!hidden')

      //show saveFeesButton
      document.getElementById('saveFeesButton').classList.add('!hidden')

      //hide feesTable
      document.getElementById('feesTable').classList.remove('!hidden')

      //show editFees
      document.getElementById('editFees').classList.add('!hidden')

      //enable addFeesButton
      document.getElementById('addFeeButton').classList.add('!hidden')
    }
  });
}

function editConditionQuestion(question) {
  questionForm.id = question.id;
  questionForm.question = question.question;
  questionForm.condition_category_id = question.condition_category_id;
  document.getElementById(`question_${question.id}_display`).classList.add('!hidden')
  document.getElementById(`question_${question.id}_input`).classList.remove('!hidden')
  document.getElementsByClassName(`question_${question.id}_pencil`)[0].classList.add('!hidden')
  document.getElementsByClassName(`question_${question.id}_check`)[0].classList.remove('!hidden')

  conditions.value.forEach(condition => {
    condition.questions.forEach(conditionQuestion => {
      if (conditionQuestion.id !== question.id) {
        document.getElementById(`question_${conditionQuestion.id}_display`).classList.remove('!hidden')
        document.getElementById(`question_${conditionQuestion.id}_input`).classList.add('!hidden')
        document.getElementsByClassName(`question_${conditionQuestion.id}_pencil`)[0].classList.remove('!hidden')
        document.getElementsByClassName(`question_${conditionQuestion.id}_check`)[0].classList.add('!hidden')
      }
    })
  });
}

function saveConditionQuestion() {
  questionForm.post(`/portal/settings/conditionQuestion`, {
    preserveScroll: true,
    onSuccess: (data) => {
      conditions.value = data.props.conditions;
      questionForm.reset();

      conditions.value.forEach(condition => {
        condition.questions.forEach(conditionQuestion => {
          document.getElementById(`question_${conditionQuestion.id}_display`).classList.remove('!hidden')
          document.getElementById(`question_${conditionQuestion.id}_input`).classList.add('!hidden')
          document.getElementsByClassName(`question_${conditionQuestion.id}_pencil`)[0].classList.remove('!hidden')
          document.getElementsByClassName(`question_${conditionQuestion.id}_check`)[0].classList.add('!hidden')
        })
      });
    }
  });
}

function deleteConditionQuestion(givenQuestion) {
  axios.delete(`/portal/settings/conditionQuestion/${givenQuestion.id}`)
    .then(response => {
      conditions.value = conditions.value.map(condition => {
        condition.questions = condition.questions.filter(question => question.id !== givenQuestion.id);
        return condition;
      })
    })
    .catch(error => {
      console.log(error)
    })

}

function addConditionQuestion(cateogryId) {
  questionForm.question = "Nieuwe vraag";
  questionForm.condition_category_id = cateogryId;
  questionForm.id = null;
  questionForm.post(`/portal/settings/conditionQuestion`, {
    preserveScroll: true,
    onSuccess: (data) => {
      conditions.value = data.props.conditions;
      questionForm.reset();
    }
  });
}

function editConditionCategory(condition) {
  conditionCategoryForm.id = condition.id;
  conditionCategoryForm.name = condition.name
  document.getElementById(`conditionCategory_${condition.id}_display`).classList.add('!hidden')
  document.getElementById(`conditionCategory_${condition.id}_input`).classList.remove('!hidden')
  document.getElementsByClassName(`conditionCategory_${condition.id}_pencil`)[0].classList.add('!hidden')
  document.getElementsByClassName(`conditionCategory_${condition.id}_check`)[0].classList.remove('!hidden')

  conditions.value.forEach(conditionValue => {
    if (conditionValue.id !== condition.id) {
      document.getElementById(`conditionCategory_${conditionValue.id}_display`).classList.remove('!hidden')
      document.getElementById(`conditionCategory_${conditionValue.id}_input`).classList.add('!hidden')
      document.getElementsByClassName(`conditionCategory_${conditionValue.id}_pencil`)[0].classList.remove('!hidden')
      document.getElementsByClassName(`conditionCategory_${conditionValue.id}_check`)[0].classList.add('!hidden')
    }
  });
}

function saveConditionCategory(id) {
  conditionCategoryForm.post(`/portal/settings/conditionCategory`, {
    preserveScroll: true,
    onSuccess: (data) => {
      conditions.value = data.props.conditions;
      conditionCategoryForm.reset();

      conditions.value.forEach(condition => {
        document.getElementById(`conditionCategory_${condition.id}_display`).classList.remove('!hidden')
        document.getElementById(`conditionCategory_${condition.id}_input`).classList.add('!hidden')
        document.getElementsByClassName(`conditionCategory_${condition.id}_pencil`)[0].classList.remove('!hidden')
        document.getElementsByClassName(`conditionCategory_${condition.id}_check`)[0].classList.add('!hidden')
      });
    }
  });
}

function deleteConditionCategory(id) {
  axios.delete(`/portal/settings/conditionCategory/${id}`)
    .then(response => {
      conditions.value = conditions.value.filter(condition => condition.id !== id);
    })
    .catch(error => {
      console.log(error)
    })
}

function addConditionCategory() {
  conditionCategoryForm.name = "Nieuwe categorie";
  conditionCategoryForm.id = null;
  conditionCategoryForm.post(`/portal/settings/conditionCategory`, {
    preserveScroll: true,
    onSuccess: (data) => {
      conditions.value = data.props.conditions;
      conditionCategoryForm.reset();
    }
  });
}

function addBrand() {
  newBrandForm.post(`/portal/settings/brand`, {
    preserveScroll: true,
    onSuccess: (data) => {
      brands.value = data.props.brands;
      newBrandForm.reset();

      brands.value.forEach(brand => {
        document.getElementById(`brand_${brand.id}_display`).classList.remove('!hidden')
        document.getElementById(`brand_${brand.id}_input`).classList.add('!hidden')
        document.getElementsByClassName(`brand_${brand.id}_pencil`)[0].classList.remove('!hidden')
        document.getElementsByClassName(`brand_${brand.id}_check`)[0].classList.add('!hidden')
      });
    }
  });
}

function deleteBrand(brand) {
  axios.delete(`/portal/settings/brand/${brand.id}`)
    .then(response => {
      brands.value = brands.value.filter(brandValue => brandValue.id !== brand.id)
    })
    .catch(error => {
      console.log(error)
    })
}

function saveBrand() {
  brandForm.post(`/portal/settings/brand`, {
    preserveScroll: true,
    onSuccess: (data) => {
      brands.value = data.props.brands;
      brandForm.reset();

      brands.value.forEach(brand => {
        document.getElementById(`brand_${brand.id}_display`).classList.remove('!hidden')
        document.getElementById(`brand_${brand.id}_input`).classList.add('!hidden')
        document.getElementsByClassName(`brand_${brand.id}_pencil`)[0].classList.remove('!hidden')
        document.getElementsByClassName(`brand_${brand.id}_check`)[0].classList.add('!hidden')
      });
    }
  });

}

function editBrand(brand) {
  brandForm.id = brand.id;
  brandForm.name = brand.name;

  document.getElementById(`brand_${brand.id}_display`).classList.add('!hidden')
  document.getElementById(`brand_${brand.id}_input`).classList.remove('!hidden')
  document.getElementsByClassName(`brand_${brand.id}_pencil`)[0].classList.add('!hidden')
  document.getElementsByClassName(`brand_${brand.id}_check`)[0].classList.remove('!hidden')

  brands.value.forEach(brandValue => {
    if (brandValue.id !== brand.id) {
      document.getElementById(`brand_${brandValue.id}_display`).classList.remove('!hidden')
      document.getElementById(`brand_${brandValue.id}_input`).classList.add('!hidden')
      document.getElementsByClassName(`brand_${brandValue.id}_pencil`)[0].classList.remove('!hidden')
      document.getElementsByClassName(`brand_${brandValue.id}_check`)[0].classList.add('!hidden')
    }
  });
}

function addCategory() {
  newCategoryForm.post(`/portal/settings/category`, {
    preserveScroll: true,
    onSuccess: (data) => {
      categories.value = data.props.categories;
      newCategoryForm.reset();

      categories.value.forEach(category => {
        if (document.getElementById(`category_${category.id}_display`)) {
          document.getElementById(`category_${category.id}_display`).classList.remove('!hidden')
          document.getElementById(`category_${category.id}_input`).classList.add('!hidden')
          document.getElementsByClassName(`category_${category.id}_pencil`)[0].classList.remove('!hidden')
          document.getElementsByClassName(`category_${category.id}_check`)[0].classList.add('!hidden')
        }
      });
    }
  });
}

function editCategory(category) {
  categoryForm.id = category.id;
  categoryForm.name = category.name;

  document.getElementById(`category_${category.id}_display`).classList.add('!hidden')
  document.getElementById(`category_${category.id}_input`).classList.remove('!hidden')
  document.getElementsByClassName(`category_${category.id}_pencil`)[0].classList.add('!hidden')
  document.getElementsByClassName(`category_${category.id}_check`)[0].classList.remove('!hidden')

  categories.value.forEach(categoryValue => {
    if (categoryValue.id !== category.id) {
      document.getElementById(`category_${categoryValue.id}_display`).classList.remove('!hidden')
      document.getElementById(`category_${categoryValue.id}_input`).classList.add('!hidden')
      document.getElementsByClassName(`category_${categoryValue.id}_pencil`)[0].classList.remove('!hidden')
      document.getElementsByClassName(`category_${categoryValue.id}_check`)[0].classList.add('!hidden')
    }
  });
}

function saveCategory() {
  categoryForm.post(`/portal/settings/category`, {
    preserveScroll: true,
    onSuccess: (data) => {
      categories.value = data.props.categories;
      categoryForm.reset();

      categories.value.forEach(category => {
        document.getElementById(`category_${category.id}_display`).classList.remove('!hidden')
        document.getElementById(`category_${category.id}_input`).classList.add('!hidden')
        document.getElementsByClassName(`category_${category.id}_pencil`)[0].classList.remove('!hidden')
        document.getElementsByClassName(`category_${category.id}_check`)[0].classList.add('!hidden')
      });
    }
  });
}

function deleteCategory(category) {
  axios.delete(`/portal/settings/category/${category.id}`)
    .then(response => {
      categories.value = categories.value.filter(categoryValue => categoryValue.id !== category.id)
    })
    .catch(error => {
      console.log(error)
    })
}

const tabs = ref([
  { id: 0, name: 'Profiel', href: '#profiel', icon: 'circle-user', current: true, dealer: false, permission: 'none' },
  { id: 1, name: 'Profiel', href: '#dealerprofiel', icon: 'circle-user', current: false, dealer: true, permission: 'none' },
  { id: 2, name: 'Notificaties', href: '#notificaties', icon: 'bell-ring', current: false, dealer: false, permission: 'none' },
  { id: 3, name: 'Merken en Categorieën', href: '#voorkeuren', icon: 'star', current: false, dealer: false, permission: 'settings-preferences' },
  { id: 4, name: 'Opties & Condities', href: '#opties', icon: 'circle-info', current: false, dealer: false, permission: 'settings-options|settings-conditions' },
  { id: 5, name: 'Fees en kosten', href: '#fees', icon: 'money-bill', current: false, dealer: false, permission: 'settings-fees' },
  { id: 6, name: 'Auto aanmelden', href: '#aanmelden', icon: 'car', current: false, dealer: false, permission: 'settings-lot-register' },
])

tabs.value.forEach(tab => {
  if (tab.dealer && !user.dealer) {
    //remove tab from list
    tabs.value = tabs.value.filter(tabValue => tabValue.id !== tab.id)
  }

  if (tab.permission == 'none') {
    return;
  }

  //check if permission contains |, if so, split the string and check if user has one of the permissions
  if (tab.permission.includes('|')) {
    const permissions = tab.permission.split('|');
    let doesHavePermission = false;
    permissions.forEach(permission => {
      if (hasPermission(permission)) {
        doesHavePermission = true;
      }
    })

    if (!doesHavePermission) {
      //remove tab from list
      tabs.value = tabs.value.filter(tabValue => tabValue.id !== tab.id)
    }
  } else {
    if (!hasPermission(tab.permission)) {
      //remove tab from list
      tabs.value = tabs.value.filter(tabValue => tabValue.id !== tab.id)
    }
  }
})

const selectTab = (selectedTab) => {
  //check if selectedTab is integer
  if (!isNaN(selectedTab)) {
    selectedTabIndex.value = selectedTab
    selectedTab = tabs.value[selectedTab]
  } else {
    selectedTabIndex.value = selectedTab.id;
  }
  tabs.value.forEach(tab => {
    tab.current = (tab === selectedTab)
  })
}

//reset tab ids
tabs.value.forEach((tab, index) => {
  tab.id = index
})

function updatePassword() {
  passwordForm.post(`/portal/settings/password`, {
    preserveScroll: true,
    onSuccess: (data) => {
      passwordForm.reset();
    },
    onError: (errors) => {
      passwordForm.reset();
    }
  });

}

const selectedTabIndex = ref(0);
const userProfileForm = useForm({
  first_name: user.value.first_name,
  infix: user.value.infix,
  last_name: user.value.last_name,
  email: user.value.email,
})

const dealerProfileForm = useForm({
  company_name: user.value.company_name,
  first_name: user.value.first_name,
  infix: user.value.infix,
  last_name: user.value.last_name,
  email: user.value.email,
  website: user.value.website,
  description: user.value.description,
  address: user.value.address,
  phone_number: user.value.phone_number,
  chamber_of_commerce_number: user.value.chamber_of_commerce_number,
  vat_number: user.value.vat_number,
})

const editProfile = ref(false);
const editPreferences = ref(false);

const selectedBrands = ref(user.value.brands.map(brand => brand.id));
const selectedCategories = ref(user.value.categories.map(category => category.id));

function saveProfile() {
  userProfileForm.post(`/portal/settings/updateSelfUser`, {
    preserveScroll: true,
    onSuccess: (data) => {
      user.value = data.props.user;
      editProfile.value = false;
    },
    onError: (errors) => {
      //
    }
  });
}

function saveDealerProfile() {
  dealerProfileForm.post(`/portal/settings/updateSelfDealer`, {
    preserveScroll: true,
    onSuccess: (data) => {
      user.value = data.props.user;
      editProfile.value = false;
    },
    onError: (errors) => {
      //
    }
  });
}

function savePreferences() {
  axios.post(`/portal/settings/updateSelfPreferences`, { brands: selectedBrands.value, categories: selectedCategories.value })
    .then(response => {
      //TODO SHOW SUCCESS MESSAGE
      editPreferences.value = false;

      //update the user object
      user.value.brands = brands.value.filter(brand => selectedBrands.value.includes(brand.id));
      user.value.categories = categories.value.filter(category => selectedCategories.value.includes(category.id));
    })
    .catch(error => {
      //
    })

}

function getAndFormatAddressData(addressData, placeResultData, id) {
  dealerProfileForm.address = JSON.stringify(addressData);
}

const addressField = ref(null)

watch(addressField, (newValue, oldValue) => {
  if(oldValue == null) {
    const latlng = { lat: user.value.address.latitude, lng: user.value.address.longitude };
    addressField.value.updateCoordinates(latlng);
  }
})

function startCompanyEdit() {
  editProfile.value = true; 
}

const categoryRequirementForm = useForm({
  min_mileage: null,
})
</script>

<template>
  <Head title="Instellingen | Mijnautosnelweg" />
  <TabGroup :selectedIndex="selectedTabIndex" >
    <div>
      <div class="sm:hidden w-full gap-x-4 px-4 sm:px-6 py-6">
        <label for="tabs" class="sr-only">Select a tab</label>
        <!-- Use an "onChange" listener to redirect the user to the selected tab URL. -->
        <select id="tabs" name="tabs" @change="selectTab($event.target.value)"
          class="block w-full rounded-md border-gray-300 focus:border-brightorange focus:ring-brightorange">
          <option v-for="tab in tabs" :key="tab.name" :selected="tab.current"
            :aria-current="tab.current ? 'page' : undefined" :value="tab.id">{{ tab.name }}</option>
        </select>
      </div>
      <TabList class="hidden sm:flex mx-auto w-full max-w-6xl gap-x-4 px-4 sm:px-6 py-6">
        <Tab v-for="tab in tabs" :key="tab.id" :href="tab.href"
          :class="[tab.current ? 'border-brightorange text-brightorange' : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700', 'group inline-flex items-center border-b-2 py-4 px-1 text-sm font-medium']"
          :aria-current="tab.current ? 'page' : undefined" @click.prevent="selectTab(tab)">
          <font-awesome-icon :icon="['far', tab.icon]" :class="[tab.current ? 'text-brightorange' : 'text-gray-400 group-hover:text-gray-500', 'h-4 w-4 shrink-0']" aria-hidden="true" />
          <span :class="[tab.current ? 'block ml-2' : 'hidden md:block ml-2']">{{ tab.name }}</span>
        </Tab>
      </TabList>
    </div>
    <TabPanels :defaultIndex="2">
      <!-- check if tabs has a tab with id 0-->
      <TabPanel class="mx-auto w-full max-w-6xl lg:flex lg:gap-x-16 px-4 sm:px-6 py-6" v-if="!user.dealer">
        <h1 class="sr-only">General Settings</h1>
        <div class="w-full space-y-16 pb-20">
          <div>
            <form @submit.prevent="saveProfile">
              <div class="flex flex-row justify-between">
                <h2 class="text-base font-semibold leading-7 text-gray-900">Mijn gegevens</h2>
                <button type="button" @click="editProfile = true" v-if="!editProfile"
                  class="text-sm font-semibold text-royalblue-500 hover:text-royalblue-500/80 hover:underline hover:underline-offset-8">Wijzigen</button>
                  <button type="submit"v-if="editProfile"
                  class="text-sm font-semibold text-brightorange hover:text-brightorange/80 hover:underline hover:underline-offset-8">Opslaan</button>
              </div>
              <dl class="mt-6 pb-6 space-y-6 divide-y divide-gray-100 border-y border-gray-200 text-sm leading-6" v-if="!editProfile">
                <div class="pt-6 sm:flex items-start space-y-2 sm:space-y-0">
                  <dt class="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6">Naam</dt>
                  <p class="text-gray-900">{{user.full_name}}</p>
                </div>
                <div class="pt-6 sm:flex items-start space-y-2 sm:space-y-0">
                  <dt class="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6">E-mailadres</dt>
                  <p class="text-gray-900">{{user.email}}</p>
                </div>
                <div class="pt-6 sm:flex items-start space-y-2 sm:space-y-0">
                  <dt class="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6">Rol</dt>
                  <dd class="mt-1 flex justify-between gap-x-6 sm:mt-0 sm:flex-auto">
                    <p class="text-gray-900">{{user.role.name}}</p>
                  </dd>
                </div>
              </dl>
              <dl class="mt-6 pb-6 space-y-6 divide-y divide-gray-100 border-y border-gray-200 text-sm leading-6" v-else>
                <div class="pt-6 sm:flex items-start space-y-2 sm:space-y-0">
                  <dt class="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6">Naam</dt>
                  <input type="text" class="input-style w-1/3" placeholder="Voornaam" v-model="userProfileForm.first_name" />
                  <input type="text" class="input-style w-1/3 ml-3" placeholder="Tussenvoegsel" v-model="userProfileForm.infix" />
                  <input type="text" class="input-style w-1/3 ml-3" placeholder="Achternaam" v-model="userProfileForm.last_name" />
                </div>
                <div v-if="userProfileForm.errors.first_name" class="text-red-500 text-sm mt-2 text-end">{{ userProfileForm.errors.first_name }}</div>
                <div v-if="userProfileForm.errors.infix" class="text-red-500 text-sm mt-2 text-end">{{ userProfileForm.errors.infix }}</div>
                <div v-if="userProfileForm.errors.last_name" class="text-red-500 text-sm mt-2 text-end">{{ userProfileForm.errors.last_name }}</div>
                <div class="pt-6 sm:flex items-start space-y-2 sm:space-y-0">
                  <dt class="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6">E-mailadres</dt>
                  <input type="email" class="input-style" placeholder="E-mailadres" v-model="userProfileForm.email" />
                </div>
                <div v-if="userProfileForm.errors.email" class="text-red-500 text-sm mt-2 text-end">{{ userProfileForm.errors.email }}</div>
                <div class="pt-6 sm:flex items-start space-y-2 sm:space-y-0">
                  <dt class="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6">Rol</dt>
                  <dd class="mt-1 flex justify-between gap-x-6 sm:mt-0 sm:flex-auto">
                    <p class="text-gray-900">{{user.role.name}}</p>
                  </dd>
                </div>
              </dl>
            </form>
          </div>

          <div>
            <form @submit.prevent="updatePassword">
              <div class="flex flex-row justify-between">
                <h2 class="text-base font-semibold leading-7 text-gray-900">Wachtwoord wijzigen</h2>
                <button type="submit"
                    class="text-sm font-semibold text-brightorange hover:text-brightorange/80 hover:underline hover:underline-offset-8">Opslaan</button>
              </div>
            
              <dl class="mt-6 pb-6 space-y-6 divide-y divide-gray-100 border-y border-gray-200 text-sm leading-6 ">
                <div class="pt-6 sm:flex items-start space-y-2 sm:space-y-0">
                  <dt class="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6">Huidig wachtwoord</dt>
                  <input type="password" class="input-style" placeholder="Huidig wachtwoord" v-model="passwordForm.current_password" />
                </div>
                <div v-if="passwordForm.errors.current_password" class="text-red-500 text-sm mt-2 text-end">{{ passwordForm.errors.current_password }}</div>
                <div class="pt-6 sm:flex items-start space-y-2 sm:space-y-0">
                  <dt class="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6">Nieuw wachtwoord</dt>
                  <div class="flex flex-col md:flex-row gap-4 w-full">
                    <input type="password" class="input-style" placeholder="Nieuw wachtwoord" v-model="passwordForm.password"/>
                  </div>
                </div>
                <div v-if="passwordForm.errors.password" class="text-red-500 text-sm mt-2 text-end">{{ passwordForm.errors.password }}</div>
                <div class="pt-6 sm:flex items-start space-y-2 sm:space-y-0">
                  <dt class="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6">Nieuw wachtwoord herhaling</dt>
                  <div class="flex flex-col md:flex-row gap-4 w-full">
                    <input type="password" class="input-style" placeholder="Nieuw wachtwoord herhaling" v-model="passwordForm.password_confirmation" />
                  </div>
                </div>
                <div v-if="passwordForm.errors.password_confirmation" class="text-red-500 text-sm mt-2 text-end">{{ passwordForm.errors.password_confirmation }}</div>
              </dl>
            </form>
          </div>
          
          <div>
            <div class="flex flex-row justify-between">
              <h2 class="text-base font-semibold leading-7 text-gray-900">Voorkeuren</h2>
              <button type="button" @click="editPreferences = true"
                class="text-sm font-semibold text-royalblue-500 hover:text-royalblue-500/80 hover:underline hover:underline-offset-8" v-if="!editPreferences">Wijzigen</button>
              <button @click="savePreferences" type="button"
                class="text-sm font-semibold text-brightorange hover:text-brightorange/80 hover:underline hover:underline-offset-8" v-if="editPreferences">Opslaan</button>
            </div>
            <div class="mt-6 pb-6 space-y-6 divide-y divide-gray-100 border-y border-gray-200 text-sm leading-6" v-if="!editPreferences">
              <div class="pt-6 sm:flex items-start space-y-2 sm:space-y-0">
                <label for="first-name" class="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6">Favoriete
                  merken</label>
                <div class=" mt-2 flex flex-wrap gap-x-2 gap-y-6">
                  <p class="text-gray-900" v-if="user.brands.length > 0">{{user.brands.map(brand => brand.name).join(', ')}}</p>
                  <p class="texzt-gray-900" v-else>Geen voorkeuren</p>
                </div>
              </div>
              <div class="pt-6 sm:flex items-start space-y-2 sm:space-y-0">
                <label for="first-name"
                  class="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6">Categorieën</label>
                <div class=" mt-2 flex flex-wrap gap-x-2 gap-y-6">
                  <p class="text-gray-900" v-if="user.categories.length > 0">{{user.categories.map(category => category.name).join(', ')}}</p>
                  <p class="texzt-gray-900" v-else>Geen voorkeuren</p>
                </div>
              </div>
            </div>
            <div class="mt-6 pb-6 space-y-6 divide-y divide-gray-100 border-y border-gray-200 text-sm leading-6" v-else>
              <div class="pt-6 sm:flex items-start space-y-2 sm:space-y-0">
                <label for="first-name" class="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6">Favoriete
                  merken</label>
                <div class=" mt-2 flex flex-wrap gap-x-2 gap-y-6">
                  <div class="mt-5 mb-4 w-full flex flex-wrap gap-y-7 gap-x-3">
                    <div v-for="brand in brands">
                      <Checkbox v-model="selectedBrands" :value="brand.id" :inputId="'brand_' + brand.id"
                        class="hidden" />
                      <label :for="'brand_' + brand.id"
                        :class="selectedBrands.includes(brand.id) ? 'bg-royalblue-500 text-white' : 'bg-transparent'"
                        class="border p-2 rounded-lg hover:bg-royalblue-500/80 text-gray-900 hover:text-white cursor-pointer transition-colors duration-200 ease-in-out">{{
                          brand.name }}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="pt-6 sm:flex items-start space-y-2 sm:space-y-0">
                <label for="first-name"
                  class="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6">Categorieën</label>
                <div class=" mt-2 flex flex-wrap gap-x-2 gap-y-6">
                  <div v-for="category in categories">
                      <Checkbox v-model="selectedCategories" :value="category.id" :inputId="'category_' + category.id"
                        class="hidden" />
                      <label :for="'category_' + category.id"
                        :class="selectedCategories.includes(category.id) ? 'bg-royalblue-500 text-white' : 'bg-transparent'"
                        class="border p-2 rounded-lg hover:bg-royalblue-500/80 text-gray-900 hover:text-white cursor-pointer transition-colors duration-200 ease-in-out">{{
                          category.name }}</label>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </TabPanel>
      <TabPanel class="mx-auto w-full max-w-6xl lg:flex lg:gap-x-16 px-4 sm:px-6 py-6" v-if="user.dealer">
        <h1 class="sr-only">Dealer Settings</h1>
        <div class="w-full space-y-16 pb-20">
          <div>
            <form @submit.prevent="saveDealerProfile">
              <div class="flex flex-row justify-between">
                <h2 class="text-base font-semibold leading-7 text-gray-900">Bedrijf gegevens</h2>
                <button type="button" @click="startCompanyEdit" v-if="!editProfile"
                  class="text-sm font-semibold text-royalblue-500 hover:text-royalblue-500/80 hover:underline hover:underline-offset-8">Wijzigen</button>
                <button type="submit" v-if="editProfile"
                  class="text-sm font-semibold text-brightorange hover:text-brightorange/80 hover:underline hover:underline-offset-8">Opslaan</button>
              </div>
              <dl class="mt-6 pb-6 space-y-6 divide-y divide-gray-100 border-y border-gray-200 text-sm leading-6">
                <div class="pt-6 sm:flex items-start space-y-2 sm:space-y-0">
                  <dt class="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6">Bedrijfsnaam</dt>
                  <p class="text-gray-900" v-if="!editProfile">{{ user.company_name }}</p>
                  <input type="text" class="input-style" placeholder="Bedrijfsnaam" v-model="dealerProfileForm.company_name"
                    v-else />
                </div>
                <div v-if="dealerProfileForm.errors.company_name" class="text-red-500 text-sm mt-2 text-end">{{ dealerProfileForm.errors.company_name }}</div>
                <div class="pt-6 sm:flex items-start space-y-2 sm:space-y-0">
                  <dt class="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6">E-mail</dt>
                  <p class="text-gray-900" v-if="!editProfile">{{ user.email }}</p>
                  <input type="email" class="input-style" placeholder="E-mail" v-model="dealerProfileForm.email" v-else />
                </div>
                <div v-if="dealerProfileForm.errors.email" class="text-red-500 text-sm mt-2 text-end">{{ dealerProfileForm.errors.email }}</div>
                <div class="pt-6 sm:flex items-start space-y-2 sm:space-y-0">
                  <dt class="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6">Contactpersoon</dt>
                  <p class="text-gray-900" v-if="!editProfile">{{ user.full_name }}</p>
                  <div v-else class="flex w-full">
                    <input type="text" class="input-style w-1/3" placeholder="Voornaam" v-model="dealerProfileForm.first_name"  />
                    <input type="text" class="input-style w-1/3 ml-3" placeholder="Tussenvoegsel" v-model="dealerProfileForm.infix"  />
                    <input type="text" class="input-style w-1/3 ml-3" placeholder="Achternaam" v-model="dealerProfileForm.last_name"  />
                  </div>
                </div>
                <div v-if="dealerProfileForm.errors.first_name" class="text-red-500 text-sm mt-2 text-end">{{ dealerProfileForm.errors.first_name }}</div>
                <div v-if="dealerProfileForm.errors.infix" class="text-red-500 text-sm mt-2 text-end">{{ dealerProfileForm.errors.infix }}</div>
                <div v-if="dealerProfileForm.errors.last_name" class="text-red-500 text-sm mt-2 text-end">{{ dealerProfileForm.errors.last_name }}</div>
                <div class="pt-6 sm:flex items-start space-y-2 sm:space-y-0">
                  <dt class="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6">Telefoonnummer</dt>
                  <p class="text-gray-900" v-if="!editProfile">{{ user.phone_number }}</p>
                  <input type="text" class="input-style" placeholder="Telefoonnummer" v-model="dealerProfileForm.phone_number" v-else />
                </div>
                <div v-if="dealerProfileForm.errors.phone_number" class="text-red-500 text-sm mt-2 text-end">{{ dealerProfileForm.errors.phone_number }}</div>
                <div class="pt-6 sm:flex items-start space-y-2 sm:space-y-0">
                  <dt class="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6">Website</dt>
                  <p class="text-gray-900" v-if="!editProfile" ><a :href="'https://' + user.website" target="_blank" class="text-royalblue-500 hover:text-royalblue-500/80 hover:underline hover:underline-offset-8" >https://{{user.website}}</a></p>
                  <InputGroup v-else>
                    <InputGroupAddon>https://www.</InputGroupAddon>
                    <InputText placeholder="Website" class="input-style" v-model="dealerProfileForm.website" />
                  </InputGroup>
                </div>
                <div v-if="dealerProfileForm.errors.website" class="text-red-500 text-sm mt-2 text-end">{{ dealerProfileForm.errors.website }}</div>
                <div class="pt-6 sm:flex items-start space-y-2 sm:space-y-0">
                  <dt class="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6">KvK nummer</dt>
                  <p class="text-gray-900" v-if="!editProfile">{{ user.chamber_of_commerce_number }}</p>
                  <input type="text" class="input-style" placeholder="KvK nummer" v-model="dealerProfileForm.chamber_of_commerce_number" v-else />
                </div>
                <div v-if="dealerProfileForm.errors.chamber_of_commerce_number" class="text-red-500 text-sm mt-2 text-end">{{ dealerProfileForm.errors.chamber_of_commerce_number }}</div>
                <div class="pt-6 sm:flex items-start space-y-2 sm:space-y-0">
                  <dt class="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6">BTW nummer</dt>
                  <p class="text-gray-900" v-if="!editProfile">{{user.vat_number}}</p>
                  <input type="text" class="input-style" placeholder="BTW nummer" v-model="dealerProfileForm.vat_number" v-else />
                </div>
                <div v-if="dealerProfileForm.errors.vat_number" class="text-red-500 text-sm mt-2 text-end">{{ dealerProfileForm.errors.vat_number }}</div>
                <div class="pt-6 sm:flex items-start space-y-2 sm:space-y-0">
                  <dt class="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6">Adres</dt>
                  <p class="text-gray-900" v-if="!editProfile">{{user.full_address}}</p>
                  <GoogleAutoComplete country="nl" name="address" id="map" v-else
                    classname="input-style" ref="addressField"
                    placeholder="Begin met typen..." :country="['nl']" v-on:placechanged="getAndFormatAddressData">
                  </GoogleAutoComplete>
                </div>
                <div v-if="dealerProfileForm.errors.address" class="text-red-500 text-sm mt-2 text-end">{{ dealerProfileForm.errors.address }}</div>
                <div class="pt-6 sm:flex items-start space-y-2 sm:space-y-0">
                  <dt class="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6">Dealer informatie</dt>
                  <p class="text-gray-900" v-if="!editProfile">{{user.description}}</p>
                  <textarea class="input-style" placeholder="Dealer informatie" v-model="dealerProfileForm.description" v-else></textarea>
                </div>
                <div v-if="dealerProfileForm.errors.description" class="text-red-500 text-sm mt-2 text-end">{{ dealerProfileForm.errors.description }}</div>
              </dl>
            </form>
          </div>

          <div>
            <form @submit.prevent="updatePassword">
              <div class="flex flex-row justify-between">
                <h2 class="text-base font-semibold leading-7 text-gray-900">Wachtwoord wijzigen</h2>
                <button type="submit"
                  class="text-sm font-semibold text-brightorange hover:text-brightorange/80 hover:underline hover:underline-offset-8">Opslaan</button>
              </div>
           
              <dl class="mt-6 pb-6 space-y-6 divide-y divide-gray-100 border-y border-gray-200 text-sm leading-6 ">
                <div class="pt-6 sm:flex items-start space-y-2 sm:space-y-0">
                  <dt class="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6">Huidig wachtwoord</dt>
                  <input type="password" class="input-style" placeholder="Huidig wachtwoord" v-model="passwordForm.current_password" />
                </div>
                <div v-if="passwordForm.errors.current_password" class="text-red-500 text-sm mt-2 text-end">{{ passwordForm.errors.current_password }}</div>
                <div class="pt-6 sm:flex items-start space-y-2 sm:space-y-0">
                  <dt class="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6">Nieuw wachtwoord</dt>
                  <div class="flex flex-col md:flex-row gap-4 w-full">
                    <input type="password" class="input-style" placeholder="Nieuw wachtwoord" v-model="passwordForm.password"/>
                  </div>
                </div>
                <div v-if="passwordForm.errors.password" class="text-red-500 text-sm mt-2 text-end">{{ passwordForm.errors.password }}</div>
                <div class="pt-6 sm:flex items-start space-y-2 sm:space-y-0">
                  <dt class="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6">Nieuw wachtwoord herhaling</dt>
                  <div class="flex flex-col md:flex-row gap-4 w-full">
                    <input type="password" class="input-style" placeholder="Nieuw wachtwoord herhaling" v-model="passwordForm.password_confirmation" />
                  </div>
                </div>
                <div v-if="passwordForm.errors.password_confirmation" class="text-red-500 text-sm mt-2 text-end">{{ passwordForm.errors.password_confirmation }}</div>
              </dl>
            </form>
          </div>
          <div>
            <div class="flex flex-row justify-between">
              <h2 class="text-base font-semibold leading-7 text-gray-900">Voorkeuren</h2>
              <button type="button" @click="editPreferences = true"
                class="text-sm font-semibold text-royalblue-500 hover:text-royalblue-500/80 hover:underline hover:underline-offset-8" v-if="!editPreferences">Wijzigen</button>
              <button @click="savePreferences" type="button"
                class="text-sm font-semibold text-brightorange hover:text-brightorange/80 hover:underline hover:underline-offset-8" v-if="editPreferences">Opslaan</button>
            </div>
            <div class="mt-6 pb-6 space-y-6 divide-y divide-gray-100 border-y border-gray-200 text-sm leading-6" v-if="!editPreferences">
              <div class="pt-6 sm:flex items-start space-y-2 sm:space-y-0">
                <label for="first-name" class="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6">Favoriete
                  merken</label>
                <div class=" mt-2 flex flex-wrap gap-x-2 gap-y-6">
                  <p class="text-gray-900" v-if="user.brands.length > 0">{{user.brands.map(brand => brand.name).join(', ')}}</p>
                  <p class="texzt-gray-900" v-else>Geen voorkeuren</p>
                </div>
              </div>
              <div class="pt-6 sm:flex items-start space-y-2 sm:space-y-0">
                <label for="first-name"
                  class="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6">Categorieën</label>
                <div class=" mt-2 flex flex-wrap gap-x-2 gap-y-6">
                  <p class="text-gray-900" v-if="user.categories.length > 0">{{user.categories.map(category => category.name).join(', ')}}</p>
                  <p class="texzt-gray-900" v-else>Geen voorkeuren</p>
                </div>
              </div>
            </div>
            <div class="mt-6 pb-6 space-y-6 divide-y divide-gray-100 border-y border-gray-200 text-sm leading-6" v-else>
              <div class="pt-6 sm:flex items-start space-y-2 sm:space-y-0">
                <label for="first-name" class="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6">Favoriete
                  merken</label>
                <div class=" mt-2 flex flex-wrap gap-x-2 gap-y-6">
                  <div class="mt-5 mb-4 w-full flex flex-wrap gap-y-7 gap-x-3">
                    <div v-for="brand in brands">
                      <Checkbox v-model="selectedBrands" :value="brand.id" :inputId="'brand_' + brand.id"
                        class="hidden" />
                      <label :for="'brand_' + brand.id"
                        :class="selectedBrands.includes(brand.id) ? 'bg-royalblue-500 text-white' : 'bg-transparent'"
                        class="border p-2 rounded-lg hover:bg-royalblue-500/80 text-gray-900 hover:text-white cursor-pointer transition-colors duration-200 ease-in-out">{{
                          brand.name }}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="pt-6 sm:flex items-start space-y-2 sm:space-y-0">
                <label for="first-name"
                  class="font-medium text-gray-900 sm:w-64 sm:flex-none sm:pr-6">Categorieën</label>
                <div class=" mt-2 flex flex-wrap gap-x-2 gap-y-6">
                  <div v-for="category in categories">
                      <Checkbox v-model="selectedCategories" :value="category.id" :inputId="'category_' + category.id"
                        class="hidden" />
                      <label :for="'category_' + category.id"
                        :class="selectedCategories.includes(category.id) ? 'bg-royalblue-500 text-white' : 'bg-transparent'"
                        class="border p-2 rounded-lg hover:bg-royalblue-500/80 text-gray-900 hover:text-white cursor-pointer transition-colors duration-200 ease-in-out">{{
                          category.name }}</label>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </TabPanel>
      <TabPanel class="mx-auto w-full max-w-6xl lg:flex lg:gap-x-16 px-4 sm:px-6 py-6">
        <h1 class="sr-only">Notification Settings</h1>
        <div class="w-full space-y-16 pb-20">
          <div>
            <div class="flex flex-row justify-between">
              <h2 class="text-base font-semibold leading-7 text-gray-900">Notificaties</h2>
            </div>
            <dl class="mt-6 pb-6 space-y-6 divide-y divide-gray-100 border-y border-gray-200 text-sm leading-6">
              <div class="pt-6 sm:flex items-start space-y-2 sm:space-y-0">
                <div class="flex flex-col lg:flex-row gap-2 lg:justify-between w-full">
                  
                  <fieldset>
                    <legend class="text-sm font-semibold leading-6 text-gray-900">Emails</legend>
                    <div class="mt-6 space-y-2">
                      <div class="relative flex gap-x-3">
                        <Switch v-model="notificationsForm.email.new_offer"
                          class="group relative inline-flex h-5 w-10 flex-shrink-0 cursor-pointer items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-brightorange focus:ring-offset-2">
                          <span class="sr-only">Use setting</span>
                          <span aria-hidden="true"
                            class="pointer-events-none absolute h-full w-full rounded-md bg-white" />
                          <span aria-hidden="true"
                            :class="[notificationsForm.email.new_offer ? 'bg-royalblue-500' : 'bg-gray-200', 'pointer-events-none absolute mx-auto h-4 w-9 rounded-full transition-colors duration-200 ease-in-out']" />
                          <span aria-hidden="true"
                            :class="[notificationsForm.email.new_offer ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none absolute left-0 inline-block h-5 w-5 transform rounded-full border border-gray-200 bg-white shadow ring-0 transition-transform duration-200 ease-in-out']" />
                        </Switch>
                        <div class="text-sm leading-6">
                          <label for="comments" class="font-medium text-gray-900">Nieuw/interessant aanbod</label>
                        </div>
                      </div>
                      <div class="relative flex gap-x-3">
                        <Switch v-model="notificationsForm.email.personal_offer"
                          class="group relative inline-flex h-5 w-10 flex-shrink-0 cursor-pointer items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-brightorange focus:ring-offset-2">
                          <span class="sr-only">Use setting</span>
                          <span aria-hidden="true"
                            class="pointer-events-none absolute h-full w-full rounded-md bg-white" />
                          <span aria-hidden="true"
                            :class="[notificationsForm.email.personal_offer ? 'bg-royalblue-500' : 'bg-gray-200', 'pointer-events-none absolute mx-auto h-4 w-9 rounded-full transition-colors duration-200 ease-in-out']" />
                          <span aria-hidden="true"
                            :class="[notificationsForm.email.personal_offer ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none absolute left-0 inline-block h-5 w-5 transform rounded-full border border-gray-200 bg-white shadow ring-0 transition-transform duration-200 ease-in-out']" />
                        </Switch>
                        <div class="text-sm leading-6">
                          <label for="comments" class="font-medium text-gray-900">Persoonlijke aanbiedingen</label>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                </div>
              </div>
            </dl>
          </div>
        </div>
      </TabPanel>
      <TabPanel class="mx-auto w-full max-w-6xl lg:flex lg:gap-x-16 px-4 sm:px-6 py-6" v-if="hasPermission('settings-preferences')">
        <div class="w-full space-y-16 pb-20">
          <div class="">
            <h2 class="text-base font-semibold leading-7 text-gray-900">Merken</h2>
            <p class="mt-1 text-sm leading-6 text-gray-500">Voeg veel voorkomende merken toe.</p>
            <table
              class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-x-6 divide-gray-100 border-t mt-6 border-gray-200 text-sm leading-6">
              <tr v-for="brand in brands" :key="brand.id">
                <td class="flex justify-between items-center py-1.5 gap-2">
                  <p class="text-gray-700" :id="'brand_' + brand.id + '_display'">{{ brand.name }}</p>
                  <input type="text" class="input-style !hidden" :id="'brand_' + brand.id + '_input'"
                    v-model="brandForm.name" />
                  <div class="flex flex-row gap-2">
                    <font-awesome-icon @click="editBrand(brand)" :icon="['fal', 'pencil']" :class="'brand_' + brand.id + '_pencil hover:cursor-pointer h-5 w-5 p-2.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-royalblue-500 hover:text-white rounded-lg shrink-0'"
                    aria-hidden="true" />
                    <font-awesome-icon @click="saveBrand(brand)" :icon="['fal', 'check']" :class="'brand_' + brand.id + '_check !hidden hover:cursor-pointer h-5 w-5 p-2.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-royalblue-500 hover:text-white rounded-lg shrink-0'"
                    aria-hidden="true" />
                    <font-awesome-icon @click="deleteBrand(brand)" :icon="['fal', 'trash-can']" class="hover:cursor-pointer h-5 w-5 p-2.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-royalblue-500 hover:text-white rounded-lg shrink-0"
                    aria-hidden="true" />
                  </div>
                </td>
              </tr>
              <tr>
                <!-- edit veld -->
                <td class="flex justify-between items-center py-1.5 gap-2">
                  <input type="text" class="input-style" placeholder="Merk" v-model="newBrandForm.name" />
                  <font-awesome-icon @click="addBrand" :icon="['fal', 'check']" class="hover:cursor-pointer h-5 w-5 p-2.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-royalblue-500 hover:text-white rounded-lg shrink-0"
                      aria-hidden="true" />
                </td>
              </tr>
            </table>
          </div>
          <div class="">
            <h2 class="text-base font-semibold leading-7 text-gray-900">Categorieën</h2>
            <p class="mt-1 text-sm leading-6 text-gray-500">Voeg de voertuig categorieën toe.</p>
            <table
              class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-x-6 divide-gray-100 border-t mt-6 border-gray-200 text-sm leading-6">
              <tr v-for="category in categories" :key="category.id">
                <td class="flex justify-between items-center py-1.5 gap-2">
                  <p class="text-gray-900" :id="'category_' + category.id + '_display'">{{ category.name }}</p>
                  <input type="text" class="input-style !hidden" :id="'category_' + category.id + '_input'"
                    v-model="categoryForm.name" />
                  <div class="flex flex-row gap-2">
                    <font-awesome-icon @click="editCategory(category)" :icon="['fal', 'pencil']" :class="'category_' + category.id + '_pencil hover:cursor-pointer h-5 w-5 p-2.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-royalblue-500 hover:text-white rounded-lg shrink-0'"
                    aria-hidden="true" />
                    <font-awesome-icon @click="saveCategory" :icon="['fal', 'check']" :class="'category_' + category.id + '_check !hidden hover:cursor-pointer h-5 w-5 p-2.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-royalblue-500 hover:text-white rounded-lg shrink-0'"
                    aria-hidden="true" />
                    <font-awesome-icon @click="deleteCategory(category)" :icon="['fal', 'trash-can']" class="hover:cursor-pointer h-5 w-5 p-2.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-royalblue-500 hover:text-white rounded-lg shrink-0"
                    aria-hidden="true" />
                  </div>
                </td>
              </tr>
              <tr>
                <!-- edit veld -->
                <td class="flex justify-between items-center pt-1 gap-2">
                  <input type="text" class="input-style" placeholder="Categorie" v-model="newCategoryForm.name" />
                  <font-awesome-icon @click="addCategory" :icon="['fal', 'check']" class="hover:cursor-pointer h-5 w-5 p-2.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-royalblue-500 hover:text-white rounded-lg shrink-0"
                      aria-hidden="true" />
                </td>
              </tr>
            </table>
          </div>
        </div>
      </TabPanel>
      <TabPanel class="mx-auto w-full max-w-6xl lg:flex lg:gap-x-16 px-4 sm:px-6 py-6" v-if="hasPermission('settings-options') || hasPermission('settings-conditions')">
        <div class="w-full space-y-16 pb-20">
          <div class="" v-if="hasPermission('settings-options')">
            <h2 class="text-base font-semibold leading-7 text-gray-900">Opties</h2>
            <p class="mt-1 text-sm leading-6 text-gray-500">Voeg veel voorkomende opties toe.</p>
            <table
              class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-x-8 divide-gray-100 border-t mt-6 py-1.5 border-gray-200 text-sm leading-6">
              <tr v-for="option in options" :key="option.id">
                <td class="flex justify-between items-center py-1.5 gap-2">
                  <p class="text-gray-700" :id="'option_' + option.id + '_display'">{{ option.name }}</p>
                  <input type="text" class="input-style !hidden" :id="'option_' + option.id + '_input'"
                    v-model="optionForm.name" />
                  <div class="flex flex-row gap-2">
                    <font-awesome-icon @click="editOption(option)" :icon="['fal', 'pencil']" :class="'option_' + option.id + '_pencil hover:cursor-pointer h-5 w-5 p-2.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-royalblue-500 hover:text-white rounded-lg shrink-0'"
                    aria-hidden="true" />
                    <font-awesome-icon @click="editOption(option)" :icon="['fal', 'check']" :class="'option_' + option.id + '_check !hidden hover:cursor-pointer h-5 w-5 p-2.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-royalblue-500 hover:text-white rounded-lg shrink-0'"
                    aria-hidden="true" />
                    <font-awesome-icon @click="deleteOption(option.id)" :icon="['fal', 'trash-can']" class="hover:cursor-pointer h-5 w-5 p-2.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-royalblue-500 hover:text-white rounded-lg shrink-0"
                    aria-hidden="true" />
                  </div>
                </td>
              </tr>
              <tr>
                <!-- edit veld -->
                <td class="flex justify-between items-center py-1.5 gap-2">
                  <input type="text" class="input-style" placeholder="Naam optie" v-model="newOptionForm.name"
                    @focus="closeOptionEdit" />
                  <font-awesome-icon @click="submitOptionForm" :icon="['fal', 'check']" class="hover:cursor-pointer h-5 w-5 p-2.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-royalblue-500 hover:text-white rounded-lg shrink-0"
                      aria-hidden="true" />
                </td>
              </tr>
            </table>
          </div>
          <div class="" v-if="hasPermission('settings-conditions')">
            <h2 class="text-base font-semibold leading-7 text-gray-900">Condities</h2>
            <p class="mt-1 text-sm leading-6 text-gray-500">Voeg de voertuig condities toe.</p>
            <table class="flex flex-col gap-x-8 mt-6 text-sm leading-6">
              <tr v-for="condition in conditions" class="border-t border-gray-200">
                <div class="flex justify-between items-center py-1.5 gap-2">
                  <p class="mt-4 pb-2 text-base font-medium leading-7 text-gray-900"
                    :id="'conditionCategory_' + condition.id + '_display'">{{ condition.name }}</p>
                  <input type="text" class="input-style !hidden" :id="'conditionCategory_' + condition.id + '_input'"
                    v-model="conditionCategoryForm.name" />
                  <div class="flex flex-row gap-2">
                    <font-awesome-icon @click="editConditionCategory(condition)" :icon="['fal', 'pencil']" :class="'conditionCategory_' + condition.id + '_pencil hover:cursor-pointer h-5 w-5 p-2.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-royalblue-500 hover:text-white rounded-lg shrink-0'"
                    aria-hidden="true" />
                    <font-awesome-icon @click="saveConditionCategory(condition)" :icon="['fal', 'check']" :class="'conditionCategory_' + condition.id + '_check !hidden hover:cursor-pointer h-5 w-5 p-2.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-royalblue-500 hover:text-white rounded-lg shrink-0'"
                    aria-hidden="true" />
                    <font-awesome-icon @click="deleteConditionCategory(condition.id)" :icon="['fal', 'trash-can']" class="hover:cursor-pointer h-5 w-5 p-2.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-royalblue-500 hover:text-white rounded-lg shrink-0"
                    aria-hidden="true" />
                  </div>
                </div>
                <td v-for="question in condition.questions" :key="condition.id" class="flex flex-col">
                  <div class="flex justify-between items-center py-1.5 gap-2">
                    <p class="text-gray-700" :id="'question_' + question.id + '_display'">{{ question.question }}</p>
                    <input type="text" class="input-style !hidden" :id="'question_' + question.id + '_input'"
                      v-model="questionForm.question" />
                    <div class="flex flex-row gap-2">
                      <font-awesome-icon @click="editConditionQuestion(question)" :icon="['fal', 'pencil']" :class="'question_' + question.id + '_pencil hover:cursor-pointer h-5 w-5 p-2.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-royalblue-500 hover:text-white rounded-lg shrink-0'"
                      aria-hidden="true" />
                      <font-awesome-icon @click="saveConditionQuestion" :icon="['fal', 'check']" :class="'question_' + question.id + '_check !hidden hover:cursor-pointer h-5 w-5 p-2.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-royalblue-500 hover:text-white rounded-lg shrink-0'"
                      aria-hidden="true" />
                      <font-awesome-icon @click="deleteConditionQuestion(question)" :icon="['fal', 'trash-can']" class="hover:cursor-pointer h-5 w-5 p-2.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-royalblue-500 hover:text-white rounded-lg shrink-0"
                      aria-hidden="true" />
                    </div>
                  </div>
                </td>
                <button type="button" @click="addConditionQuestion(condition.id)"
                  class="w-full py-3 text-sm font-semibold leading-6 text-royalblue-500 hover:text-royalblue-500/80 hover:underline underline-offset-8 text-left"><span
                    aria-hidden="true">+</span> Voeg vraag toe</button>
              </tr>
            </table>
            <button type="button" @click="addConditionCategory"
              class="w-full border-t border-gray-200 mt-6 py-3 text-sm font-semibold leading-6 text-royalblue-500 hover:text-royalblue-500/80 hover:underline underline-offset-8 text-left"><span
                aria-hidden="true">+</span> Voeg categorie toe</button>
          </div>
        </div>
      </TabPanel>
      <TabPanel class="mx-auto w-full max-w-6xl lg:flex lg:gap-x-16 px-4 sm:px-6 py-6" v-if="hasPermission('settings-fees')">
        <div class="w-full space-y-16 pb-20">
          <div class="">
            <div class="sm:flex sm:items-center">
              <div class="sm:flex-auto">
                <h1 class="text-base font-semibold leading-6 text-gray-900">Fees</h1>
                <p class="mt-2 text-sm text-gray-700">Hieronder een overzicht van de fees en kosten voor gebruik van het
                  platform.</p>
              </div>
              <div class="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
                <button type="button" @click="editFees" id="editFeesButton"
                  class="text-sm font-semibold text-royalblue-500 hover:text-royalblue-500/80 hover:underline hover:underline-offset-8">
                  Wijzigen</button>
                <button type="button" @click="saveFees" id="saveFeesButton"
                  class="!hidden text-sm font-semibold text-brightorange hover:text-brightorange/80 hover:underline hover:underline-offset-8">
                  Opslaan</button>
              </div>
            </div>
            <div class="mt-10 ring-1 ring-gray-300 rounded-lg w-full" id="feesTable">
              <table class="min-w-full divide-y divide-gray-300 border-b">
                <thead class="">
                  <tr>
                    <th scope="col"
                      class="w-1/4 py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-3">
                      Bedragen tot
                    </th>
                    <th scope="col"
                      class="w-1/4 hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:table-cell">Fee
                      in
                      euro's</th>
                  </tr>
                </thead>
                <tbody class="divide-y">
                  <tr v-for="fee in props.fees" :key="fee.amount">
                    <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-3">{{
                      eurFormatter.format(fee.max) }}</td>
                    <td class="hidden whitespace-nowrap px-3 py-4 text-sm text-gray-500 sm:table-cell">{{
                      eurFormatter.format(fee.fee)
                    }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="mt-10 ring-1 ring-gray-300 rounded-lg w-full !hidden" id="editFees">
              <table class="min-w-full divide-y divide-gray-300 border-b">
                <thead class="">
                  <tr>
                    <th scope="col"
                      class="w-1/4 py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-3">
                      Bedragen tot
                    </th>
                    <th scope="col" class="w-1/4 px-3 py-3.5 text-left text-sm font-semibold text-gray-900 table-cell">
                      Fee in
                      euro's</th>
                  </tr>
                </thead>
                <tbody class="divide-y text-sm text-gray-500 rowList">
                  <tr v-for="(fee, index) in feeForm.max">
                    <td class="w-1/4 p-3">
                      <InputNumber v-model="feeForm.max[index]" inputId="locale-netherlands" mode="currency"
                        currency="EUR" placeholder="Bedrag tot" locale="nl-NL" :minFractionDigits="0" fluid
                        class="input-style" />
                    </td>
                    <td class="p-3 flex w-full space-x-4">
                      <InputNumber v-model="feeForm.fee[index]" inputId="locale-netherlands" mode="currency"
                        currency="EUR" placeholder="Fee" locale="nl-NL" :minFractionDigits="0" fluid
                        class="input-style" />
                      <font-awesome-icon @click="deleteFee(index)" :icon="['fal', 'trash-can']" class="hover:cursor-pointer h-5 w-5 p-2.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-royalblue-500 hover:text-white rounded-lg shrink-0"
                      aria-hidden="true" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <button type="button" @click="addFee" id="addFeeButton"
              class="!hidden w-full py-3 text-sm font-semibold leading-6 text-royalblue-500 hover:text-royalblue-500/80 hover:underline underline-offset-8 text-left"><span
                aria-hidden="true">+</span> Voeg fee toe</button>
          </div>
          <p class="text-sm">Mocht er een auto verkocht worden met een fee wat niet in deze tabel staat, word automatisch de hoogste fee toegepast.</p>
        </div>
      </TabPanel>
      <TabPanel class="mx-auto w-full max-w-6xl lg:flex lg:gap-x-16 px-4 sm:px-6 py-6" v-if="hasPermission('settings-lot-register')">
        <div class="w-full space-y-16 pb-20">
          <div class="">
            <div class="sm:flex sm:items-center">
              <div class="sm:flex-auto">
                <h1 class="text-base font-semibold leading-6 text-gray-900">Welke opties worden getoond bij het
                  aanmelden van de auto</h1>
                <p class="mt-2 text-sm text-gray-700">Klik hieronder de opties aan die je op het scherm wilt zien bij
                  het aanmelden van een auto.</p>
              </div>
              <button type="button" @click="saveFrontendOptions"
                class="text-sm font-semibold text-brightorange hover:text-brightorange/80 hover:underline hover:underline-offset-8">
                Opslaan</button>
            </div>
            <div class="mt-10 w-full flex flex-wrap gap-y-7 gap-x-3">
              <div v-for="option in options">
                <Checkbox v-model="frontendOptions" :value="option.id" :inputId="'option_' + option.id"
                  class="hidden" />
                <label :for="'option_' + option.id"
                  :class="frontendOptions.includes(option.id) ? 'bg-royalblue-500 text-white' : 'bg-transparent'"
                  class="border p-2 rounded-lg hover:bg-royalblue-500/80 text-gray-900 hover:text-white cursor-pointer transition-colors duration-200 ease-in-out">{{
                    option.name }}</label>
              </div>
            </div>
          </div>
        </div>
      </TabPanel>
    </TabPanels>
  </TabGroup>
</template>
